import React from "react";
import { useTranslation } from "react-i18next";

export const AROOM_ALBUM_VISIBILITY = {
  Public: 1,
  VerifiedMembers: 2,
  IndividuallyApproved: 3,
};

const ARoomAlbumPolicyFields = ({ value, onChange, isPrivateARoom = false }) => {
  const { t } = useTranslation("common");
  const containsMinors = value.ContainsMinors === true;
  const visibility = containsMinors
    ? AROOM_ALBUM_VISIBILITY.IndividuallyApproved
    : Number(value.ARoomVisibility ?? AROOM_ALBUM_VISIBILITY.Public);

  const set = (patch) => onChange({ ...value, ...patch });
  const setMinors = (next) => set({
    ContainsMinors: next,
    ARoomVisibility: next ? AROOM_ALBUM_VISIBILITY.IndividuallyApproved : visibility,
    ConsentConfirmed: next ? value.ConsentConfirmed : false,
  });

  return (
    <section style={s.section}>
      <strong style={s.title}>{t("aRoomAlbumPolicy.title")}</strong>
      <label style={s.checkboxRow}>
        <input type="checkbox" checked={containsMinors} onChange={(e) => setMinors(e.target.checked)} />
        <span>{t("aRoomAlbumPolicy.containsMinors")}</span>
      </label>

      <label style={s.label}>{t("aRoomAlbumPolicy.whoCanAccess")}</label>
      <select
        className="input"
        value={visibility}
        disabled={containsMinors}
        onChange={(e) => set({ ARoomVisibility: Number(e.target.value) })}
      >
        {!isPrivateARoom && <option value={AROOM_ALBUM_VISIBILITY.Public}>{t("aRoomAlbumPolicy.follower")}</option>}
        <option value={AROOM_ALBUM_VISIBILITY.VerifiedMembers}>{t("aRoomAlbumPolicy.membersOnly")}</option>
        <option value={AROOM_ALBUM_VISIBILITY.IndividuallyApproved}>{t("aRoomAlbumPolicy.individualApproval")}</option>
      </select>

      {containsMinors && <div style={s.attention}>
        <span>{t("aRoomAlbumPolicy.minorsConsent")}</span>
        <span style={s.individualOnly}>{t("aRoomAlbumPolicy.minorsIndividualOnly")}</span>
      </div>}
    </section>
  );
};

const s = {
  section: { marginTop: 16, padding: "14px", border: "1px solid #eadff0", borderRadius: 10, background: "#fcf9fd" },
  title: { display: "block", marginBottom: 10, fontSize: 14 },
  checkboxRow: { display: "flex", alignItems: "center", gap: 8, marginBottom: 12, fontWeight: 600, fontSize: 13, color: "#333", cursor: "pointer" },
  label: { display: "block", fontWeight: 600, fontSize: 13, color: "#333", marginBottom: 6 },
  attention: { display: "flex", flexDirection: "column", gap: 8, marginTop: 12, fontSize: 12.5, lineHeight: 1.4, color: "#5a2d6e" },
  individualOnly: { fontWeight: 700 },
};

export default ARoomAlbumPolicyFields;
